<div class="container-component">
  <div class="bd-header">
    <div class="title">
      <span id="inicio">&nbsp;</span>
      <h2 class="title-2 mt-5">BDC_GOV.CO V.4.0</h2>
    </div>
    <p class="text-black"><span class="workSans-medium">¡Bienvenidos!</span> La Biblioteca Digital de Componentes (BDC),
      en su versión 4
      (v.4), permite a las entidades implementar en sus sitios webs los estándares del Portal Único del Estado
      Colombiano (www.gov.co) de una manera más ágil y práctica.</p>
    <hr _ngcontent-onu-c62="" class="hr-divider">
    <div class="spacing-after-divisor"></div>
  </div>
  <div class="bd-menu">
    <app-menu-component [content]="content" [urlComponent]="urlComponent"></app-menu-component>
  </div>

  <div class="bd-content">

    <h2 [id]="content[1].id" class="title-2 link-target empty-title"></h2>
    <div class="row align-items-center">
      <div class="col- col-sm-12 col-md-12 col-lg-4 col-xl-3 my-sm-3 my-3 my-lg-0">
        <div class="containerImg" data-bs-toggle="modal" data-bs-target="#modalImg">
          <img
            src="https://govco-prod-webutils.s3.amazonaws.com/uploads/2022-06-11/dcef3fb8-2b04-4109-b02c-1c54489a92d0-Img_BibliotecaBdcv4.png"
            class="card-img" alt="Biblioteca">
        </div>
      </div>
      <div class="col- col-sm-12 col-md-12 col-lg-8 col-xl-9 pl-xl-0 pr-4">
        <p><span class="montserrat-SemiBold text-black">La versión 4 (v.4) de la Biblioteca Digital de Componentes (BDC)
            le
            permitirá implementar los distintos componentes que forman parte del entorno www.gov.co.</span></p>
        <p class="mb-0">Usted puede tomar cada componente por separado -uno a uno- y solo el que necesite o
          aplique para su caso;
          funcionalidad que solo está disponible en esta última versión (v.4) de la BDC.</p>
      </div>
    </div>



    <h3 [id]="content[2].id" class="title-2 link-target">¿Cómo integrarse al Portal Único del Estado Colombiano
      (WWW.GOV.CO)?</h3>

    <p>Existen diferentes opciones para aplicar en su sitio web los estándares del Portal Único del Estado Colombiano
      (www.gov.co) a través de la Biblioteca Digital de componentes (BDC): descarga del código fuente en el repositorio
      o URL’s de acceso a las librerías.</p>

    <p>Por tanto, para hacer uso de cualquier componente de la BDC e implementarlo en el sitio web de
      su entidad, usted puede:</p>

    <div class="row margin-icons pt-3">
      <div class="col- col-sm-12 col-md-12 col-lg-4 col-xl-4 mb-4 pl-0 pr-3 mr-2">
        <div class="containerIcon" data-bs-toggle="modal" data-bs-target="#modalIcons">
          <div class="backgroundIcon">
            <span class="boxIcon govco-copy"></span>
          </div>
          <p>Copiar el código</p>
        </div>
      </div>
      <div class="col- col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-4 pl-0 px-lg-3">
        <div class="containerIcon" data-bs-toggle="modal" data-bs-target="#modalIcons">
          <div class="backgroundIcon">
            <span class="boxIcon govco-file-download"></span>
          </div>
          <p>Descargar el CSS, el <br>HTML y el JavaScript</p>
        </div>
      </div>
      <div class="col- col-sm-12 col-md-12 col-lg-6 col-xl-6 mb-4 px-0">
        <div class="containerIcon" data-bs-toggle="modal" data-bs-target="#modalIcons">
          <div class="backgroundIcon">
            <span class="boxIcon govco-file-code"></span>
          </div>
          <p>Importarlos a <br>su página web</p>
        </div>
      </div>
    </div>

    <p class="mt-1">También puede copiar la dirección enlace con el dominio de www.gov.co.</p>

    <h3 [id]="content[3].id" class="title-2 link-target">{{content[3].nombre}}</h3>
    <p>Importe los siguientes elementos desde su index.html.</p>
    <h4 id="instalacion" class="title-5 link-target title-margin-bottom">Instalación</h4>

    <div class="mb-4" aria-label="Código fuente" tabindex="0">
      <app-code-render [code]="defaults['css_cdn']" [language]="'html'"></app-code-render>

    </div>
    <div class="mb-4" aria-label="Código fuente" tabindex="0">
      <app-code-render [code]="defaults['utils.js']" [language]="'html'"></app-code-render>
    </div>
    <h4 id="dependencia" class="title-5 link-target title-margin-bottom">Dependencias</h4>
    <p>Bootstrap v.5.0.2 </p>

    <p class="vinculo-iconos parrafo-2">Descargue la fuente iconográfica, para los componentes que así lo requieran,
      desde el
      repositorio de código GIT.</p>
    <a type="button" class="btn btn-primary btn-GL parrafo-2" href="{{fuenteIconografica}}" target="_blank">
      <span class="imgGL govco-gitlab"></span>
      <span class="spanGL">Ver en GitLab</span>
    </a>
    <p class="vinculo-iconos">
      Recuerde que puede acceder al documento <span>Readme.md</span> para hacer un uso óptimo de los componenentes del
      BDC.
    </p>


    <div class="mb-4" aria-label="Código fuente">
      <app-code-render [code]="defaults['css_bootstrap']" [language]="'html'"></app-code-render>
    </div>
    <div class="mb-4" aria-label="Código fuente" tabindex="0">
      <app-code-render [code]="defaults['js_bootstrap']" [language]="'html'"></app-code-render>
    </div>

    <h3 [id]="content[4].id" class="title-2 link-target">{{content[4].nombre}}</h3>

    <p>Al vincular su entidad al Portal Único del Estado Colombiano (www.gov.co) disfrutará de los siguientes
      beneficios:
    </p>
    <div class="row">
      <div class="col- col-sm-8 col-md-8 col-lg-6 col-xl-4 my-3 p-3">
        <div class="box-shadow-govco text-center container-img-ventajas img1">
        </div>
        <p class="text-left mt-3">Su integración a los lineamientos de Gobierno Digital será más sencilla.</p>
      </div>
      <div class="col- col-sm-8 col-md-8 col-lg-6 col-xl-4 my-3 p-3">
        <div class="box-shadow-govco text-center container-img-ventajas img2">
        </div>
        <p class="text-left mt-3">Su portal electrónico será más ágil.</p>
      </div>
      <div class="col- col-sm-8 col-md-8 col-lg-6 col-xl-4 my-3 p-3">
        <div class="box-shadow-govco text-center container-img-ventajas img3">
        </div>
        <p class="text-left mt-3">Sus productos estarán más actualizados.</p>
      </div>
    </div>
    <h3 [id]="content[5].id" class="title-2 link-target">{{content[5].nombre}}</h3>

    <p>Con estos paquetes puede verificar si sus páginas están cumpliendo con los estándares de calidad actuales.</p>
    <div class="row">
      <div class="col-11 box-shadow-govco m-2 p-4 container-kit">
        <div class="text-center container-img img4">
        </div>
        <div class="">
          <div class="container-description">
            <span class="txt-2"><a href="#">Kit de usabilidad / herramientas</a></span>
            <p class="">
              Compruebe que su producto digital es fácil de usar y ofrece una buena experiencia de usuario.
            </p>
            <div>
              <a class="txt-1 mr-4" href="">Ver PDF</a>
              <a class="txt-1" href="">Ver original</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-11 box-shadow-govco m-2 p-4 container-kit">
        <div class="text-center container-img img5">
        </div>
        <div class="">
          <div class="container-description">
            <span class="txt-2"><a href="#">Kit de accesibilidad / herramientas</a></span>
            <p class="">
              Verifique que sus sistemas de información cumplen con los criterios de Accesibilidad para el Contenido Web
              (WCAG 2.1) como textos comprensibles, funcionalidades operables, herramientas compatibles, etc.
            </p>
          </div>
          <div>
            <a class="txt-1 mr-4" href="">Ver PDF</a>
            <a class="txt-1" href="">Ver original</a>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-11 box-shadow-govco m-2 p-4 container-kit">
        <div class="text-center container-img img6">
        </div>
        <div class="">
          <div class="container-description">
            <span class="txt-2"><a href="#">Kit UI V.7</a></span>
            <p class="">
              Use y aplique adecuadamente los componentes de la BDC siguiendo las indicaciones de los expertos en diseño
              y
              teniendo en cuenta los consejos de usabilidad, accesibilidad y buenas prácticas de implementación.
            </p>
          </div>
          <div>
            <a class="txt-1 mr-4" href="">Ver PDF</a>
            <a class="txt-1" href="">Ver original</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>